import { render, staticRenderFns } from "./insertBanksOpeningBalance.vue?vue&type=template&id=2529000a&scoped=true"
import script from "./insertBanksOpeningBalance.vue?vue&type=script&lang=js"
export * from "./insertBanksOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./insertBanksOpeningBalance.vue?vue&type=style&index=0&id=2529000a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529000a",
  null
  
)

export default component.exports